module.exports = __webpack_public_path__ + "static/media/vanessa-theme.517b3534.wav";